<template>
  <el-form inline>
    <el-form-item :label="title" required>
      <customer-auto-complete :value.sync="autoComplete.supplier"
                              :default-value="defaultCustomer"
                              @clear="clearSupplier"
                              @setValue="setSupplier"/>
    </el-form-item>
    <el-form-item label="联系人" v-if="customerIsshow">
      <el-select :value="values.contact"
                 placeholder="请选择联系人"
                 @change="selectContact"
                 style="width:205px">
        <el-option v-for="item in contactList"
                   :key="JSON.stringify(item)"
                   :label="item.contactName"
                   :value="JSON.stringify(item)"/>
      </el-select>
    </el-form-item>
    <el-form-item label="联系方式" v-if="customerIsshow">
      <el-input v-model="customer.phoneNumber" disabled/>
    </el-form-item>
    <!-- <el-form-item label="收货地址">
      <el-input v-model="customer.contactAddress" placeholder="请输入收货地址"/>
    </el-form-item> -->
    <el-form-item label="负责人" v-if="customerIsshow">
      <el-input v-model="customer.custUserName" disabled/>
    </el-form-item>
    <el-form-item label="组别" v-if="customerIsshow">
      <el-input v-model="customer.custDeptName" disabled/>
    </el-form-item>
    <el-form-item label="客户编号" v-if="customerIsshow">
      <el-input v-model="customer.custGoodsNo" placeholder="请输入客户编号"/>
    </el-form-item>
    <el-form-item label="客户色号" v-if="customerIsshow">
      <el-input v-model="customer.custColorName" placeholder="请输入客户色号"/>
    </el-form-item>
    <el-form-item label="客户款号" v-if="customerIsshow">
      <el-input v-model="customer.modelNumber" placeholder="请输入客户款号"/>
    </el-form-item>
    <slot/>
  </el-form>
</template>

<script>
/**
 * @Description: 供应商组件
 * @Author: 菩萨蛮
 * @Date: 2021/3/23 5:01 下午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'SaleOrderCustForm',
  props: {
    supplier: { type: Object, default: () => ({}) },
    title: { type: String, default: '供应商名称' },
    isDefault: { type: Boolean, default: false }
  },
  data() {
    return {
      customer: {
        custName: '',
        contactName: '',
        phoneNumber: '',
        contactAddress: '',
        custUserId: '',
        custUserName: '',
        custDeptId: '',
        custDeptName: '',
        custGoodsNo: '',
        modelNumber: '',
        custColorName: ''
      },
      customerIsshow: false,
      defaultCustomer: undefined,
      autoComplete: {
        supplier: ''
      },
      values: {
        supplierId: ''
      },
      contactList: []
    };
  },
  created() {
    if (this.supplier && !this.utils.isEmpty(this.supplier.custName)) {
      this.setDefaultValue();
    }
  },
  watch: {
    supplier: {
      deep: true,
      handler() {
        if (this.supplier && !this.utils.isEmpty(this.supplier.custName) && (
          JSON.stringify(this.supplier) !== JSON.stringify((this.customer))
        )) {
          this.setDefaultValue();
        }
      }
    },
    customer: {
      deep: true,
      handler() {
        if (JSON.stringify(this.supplier) !== JSON.stringify((this.customer))) {
          this.$emit('update:supplier', this.customer);
        }
      }
    }
  },
  methods: {
    selectContact(item) {
      const contact = JSON.parse(item);
      this.values.contact = item;
      this.customer.contactName = contact.contactName;
      this.customer.phoneNumber = contact.phoneNumber;
    },
    /**
     * 设置默认值方法
     */
    async setDefaultValue() {
      if (this.isDefault) {
        this.customerIsshow = true;
        const customer = this.utils.copy(this.customer);
        const { isEmpty, notEmptyArr } = this.utils;
        // 设置默认值

        // 公司名称
        customer.custName = this.supplier.custName;
        customer.contactName = this.supplier.contactName;
        this.defaultCustomer = this.supplier.custName;
        // 联系人 （选中联系人在下面）
        customer.phoneNumber = this.supplier.phoneNumber;
        customer.custUserId = this.supplier.custUserId;
        customer.userName = this.supplier.userName;
        customer.custDeptId = this.supplier.custDeptId;
        customer.custDeptName = this.supplier.custDeptName;
        customer.custGoodsNo = this.supplier.custGoodsNo;
        customer.modelNumber = this.supplier.modelNumber;
        customer.contactAddress = this.supplier.contactAddress;
        customer.custUserName = this.supplier.custUserName;
        // customer.custGoodsNo = this.supplier.custGoodsNo;
        customer.custColorName = this.supplier.custColorName;
        this.contactList = this.supplier.contactList;

        const { data } = await this.qGet(`customer/info?queryStatus=1&custName=${this.supplier.custName}`);
        const { datas } = data;
        if (notEmptyArr(datas)) {
          const c = datas[0];
          // 设置初始值
          this.contactList = c.contactList;
        }

        const { phoneNumber, contactName } = this.supplier;
        // 如果联系人和联系电话不为空
        if (!isEmpty(contactName) && !isEmpty(phoneNumber) && notEmptyArr(this.contactList)) {
          const contact = this.contactList
            .filter(e => e.contactName === contactName && e.phoneNumber === phoneNumber);
          if (contact.length > 0) {
            this.values.contact = JSON.stringify(contact[0]);
          }
        }

        this.customer = {
          ...this.supplier,
          ...customer
        };
      }
    },
    /**
     * 选中客户后设置方法
     * @param item 客户信息
     */
    setSupplier(item) {
      this.customerIsshow = true;
      this.$emit('setSettlePlans', item.settlePlans);
      this.customer.custName = item.custName;
      this.customer.custUserId = item.userId;
      this.customer.custUserName = item.userName;
      this.customer.custDeptId = item.deptId;
      this.customer.custDeptName = item.deptName;
      this.customer.custId = item.id;
      const { notEmptyArr } = this.utils;
      if (notEmptyArr(item.contactList)) {
        this.contactList = item.contactList;
        const mainContact = item.contactList.filter(c => c.main)[0];
        this.values.contact = JSON.stringify(mainContact);
        this.customer.contactName = mainContact.contactName;
        this.customer.phoneNumber = mainContact.phoneNumber;
      }
    },
    clearSupplier() {
      this.customerIsshow = false;
      this.autoComplete.supplier = '';
      this.values = { contact: '' };
      this.contactList = [];
      this.customer.custId = '';
      this.customer.custName = '';
      this.customer.contactName = '';
      this.customer.phoneNumber = '';
      this.customer.custUserId = '';
      this.customer.custUserName = '';
      this.customer.custDeptId = '';
      this.customer.custDeptName = '';
      this.customer.custGoodsNo = '';
      this.customer.modelNumber = '';
      this.customer.contactAddress = '';
      this.$emit('setDefaultCurrencyUnit', '');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
